import fetch from 'utils/fetch';


export function uploadOrderExcel(files,type) {
    const data = {
        files,
        type
    };
    return fetch({
        url: '/uploadOrderExcel',
        method: 'post',
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/orderExcel.js